import { useMemo } from 'react';
import cloneDeep from 'lodash.clonedeep';

const useCloneDeep = value => useMemo(() => cloneDeep(value), [value]);

export default useCloneDeep;
